import script from "./AuthShowcase.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthShowcase.vue?vue&type=script&setup=true&lang=js"

import "./AuthShowcase.vue?vue&type=style&index=0&id=22f2f608&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f2f608"]])

export default __exports__